import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {MyBillsModel} from '../../_models/utilities-online.models';

export const load = createAction(
    '[Utilities Online] Load',
    props<{ uuid: string }>()
);

export const loadSuccess = createAction(
    '[Utilities Online] Load Success',
    props<{ uuid: string, data: MyBillsModel }>()
);

export const loadFailure = createAction(
    '[Utilities Online] Load Failure',
    props<{ error: HttpErrorResponse }>()
);
